export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AuthLayout.vue?vue&type=template&id=348e4c61&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/AuthLayout.vue?vue&type=template&id=348e4c61&scoped=true
// module id = 1632
// module chunks = 31